import { render } from "./DstToUserArts.vue?vue&type=template&id=7351e223&scoped=true"
import script from "./DstToUserArts.vue?vue&type=script&lang=js"
export * from "./DstToUserArts.vue?vue&type=script&lang=js"

import "./DstToUserArts.vue?vue&type=style&index=0&id=7351e223&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7351e223"]])

export default __exports__